<router-outlet />
<app-common-loader></app-common-loader>
